let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("dlmud"), load("bNv64"), load("5CGnz"), load("9yemY")]).then(() => parcelRequire('jwDkc'));